export const ROUTES = {
  LOGIN: '/login',
  OAUTH_CALLBACK: '/oauth/code/google',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  CRM_PRODUCT_UPDATES: '/crm/product-updates',
  COMPANIES: '/companies',
  TENANT_360: '/companies/:companyId/360',
  AUDIT: '/audit',
  SETTINGS: '/settings',
  APPSTORE: '/appstore',
  SUBSCRIPTIONS: '/subscriptions',
  SUBSCRIPTION_COMPANIES: '/subscriptions/companies',
  SUBSCRIPTION_PLANS: '/subscriptions/plans',
  SUBSCRIPTION_CUSTOM_PRODUCTS: '/subscriptions/custom-products',
  SUPPORT: '/support',
  SUPPORT_TICKETS: '/support/tickets',
  SUPPORT_CATEGORIES: '/support/categories',
  SUPPORT_QUEUES: '/support/queues',
  SUPPORT_REPORTS: '/support/reports',
  SUPPORT_GOD_ADMIN: '/support/god-admin',
} as const;

export function tenant360Path(companyId: string) {
  return `/companies/${companyId}/360`;
}
